import api from './api';

const giftScreenshotService = {
  /**
   * 获取最近的直播场次列表
   */
  getBroadcasts: async (roomId, limit = 10) => {
    const response = await api.get(`/gift-screenshot/broadcasts/${roomId}`, {
      params: { limit }
    });
    return response.data;
  },

  /**
   * 根据时间范围获取可选的礼物列表
   */
  getAvailableGifts: async (roomId, startTime, endTime) => {
    const response = await api.get(`/gift-screenshot/available-gifts/${roomId}`, {
      params: { startTime, endTime }
    });
    return response.data;
  },

  /**
   * 根据时间范围获取活跃用户列表
   */
  getActiveUsers: async (roomId, startTime, endTime) => {
    const response = await api.get(`/gift-screenshot/users/${roomId}`, {
      params: { startTime, endTime }
    });
    return response.data;
  },

  /**
   * 根据筛选条件查询礼物数据
   */
  getGifts: async (roomId, options = {}) => {
    const {
      startTime,
      endTime,
      giftIds,
      userIds,
      minValue,
      maxValue,
      sortBy = 'time',
      sortOrder = 'desc',
      mergeGifts = false,
      useNickname = false,
      limit
    } = options;

    const params = {
      startTime,
      endTime,
      sortBy,
      sortOrder,
      mergeGifts: mergeGifts ? 'true' : 'false',
      useNickname: useNickname ? 'true' : 'false'
    };

    if (giftIds && giftIds.length > 0) {
      params.giftIds = giftIds.join(',');
    }
    if (userIds && userIds.length > 0) {
      params.userIds = userIds.join(',');
    }
    if (minValue !== undefined && minValue !== null) {
      params.minValue = minValue;
    }
    if (maxValue !== undefined && maxValue !== null) {
      params.maxValue = maxValue;
    }
    if (limit) {
      params.limit = limit;
    }

    const response = await api.get(`/gift-screenshot/gifts/${roomId}`, { params });
    return response.data;
  },

  /**
   * 批量获取用户头像
   */
  getUserFaces: async (uids) => {
    const response = await api.post('/gift-screenshot/user-faces', { uids });
    return response.data;
  },

  /**
   * 批量获取用户大航海等级
   */
  getUserGuardLevels: async (roomId, uids) => {
    const response = await api.post(`/gift-screenshot/user-guard-levels/${roomId}`, { uids });
    return response.data;
  }
};

export default giftScreenshotService;
